<template>
  <div class="page">
    <h1 class="mt-0 mb-3">Настройки</h1>
    <el-tabs class="flex-1" type="border-card" @tab-click="onChangeTab"  :value="activeTab">
      <el-tab-pane v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name">
        <component v-bind:is="tab.component" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ImageSaveSettingsForm from '@/components/settings/ImageSaveSettingsForm';
import CommonsSettings from '@/components/settings/CommonsSettings';

export default {
  components: {
    ImageSaveSettingsForm,
    CommonsSettings,
  },
  data: () => ({
    activeTab: '',
    tabs: [
      {
        name: 'image',
        label: 'Хранение изображений',
        component: 'ImageSaveSettingsForm',
      },
      {
        name: 'commons',
        label: 'Общие',
        component: 'CommonsSettings',
      },
    ],
  }),
  methods: {
    onChangeTab(tab) {
      this.activeTab = tab.name;
    },
  },
  watch: {
    activeTab(newVal) {
      if (this.$route.query.tab !== newVal) {
        const query = { ...this.$route.query, tab: newVal };
        this.$router.push({ ...this.$route, query });
      }
    },
  },
  created() {
    if (this.$route.query.tab) {
      this.activeTab = this.$route.query.tab;
    } else {
      this.activeTab = this.tabs[0]?.name;
    }
  },
};
</script>
